import app from 'flarum/common/app';
export const TICKET_STATUSES = ['open', 'pending', 'resolved', 'closed'];
export const TICKET_PRIORITIES = ['low', 'normal', 'high'];
export const STATUS_ICONS = {
  open: 'far fa-circle-dot',
  pending: 'fas fa-hourglass-half',
  resolved: 'fas fa-check',
  closed: 'fas fa-lock'
};
export function isTicket(discussion) {
  return !!discussion.isTicket();
}
export function ticketAssignees(discussion) {
  return (discussion.ticketAssignees() || []).filter(user => !!user);
}

/**
 * The guest who opened a ticket without an account (only staff get this).
 */
export function ticketGuest(discussion) {
  return discussion?.ticketGuest() || null;
}
export function guestTicketsEnabled() {
  return !!app.forum.attribute('supportGuestTickets');
}
export function canStartTicket() {
  return !!app.forum.attribute('canStartTicket');
}
export function canManageTickets() {
  return !!app.forum.attribute('canManageTickets');
}
export function statusLabel(status) {
  return app.translator.trans(`soup-97-support.lib.ticket_status.${status}`);
}
export function priorityLabel(priority) {
  return app.translator.trans(`soup-97-support.lib.ticket_priority.${priority}`);
}
flarum.reg.add('soup-97-support', 'common/utils/tickets', { TICKET_STATUSES: TICKET_STATUSES,TICKET_PRIORITIES: TICKET_PRIORITIES,STATUS_ICONS: STATUS_ICONS,isTicket: isTicket,ticketAssignees: ticketAssignees,ticketGuest: ticketGuest,guestTicketsEnabled: guestTicketsEnabled,canStartTicket: canStartTicket,canManageTickets: canManageTickets,statusLabel: statusLabel,priorityLabel: priorityLabel, });